module.exports = __webpack_public_path__ + "static/media/mozza_bogo-dt-fr.ba24b891.jpg";